"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseExpression = exports.parseStatement = exports.parseModule = exports.parse = void 0;
const util_1 = require("../util");
const pegjsParsers_1 = require("./pegjsParsers");
function parse(source) {
    try {
        const ast = parseModule(source);
        return util_1.success(ast);
    }
    catch (e) {
        return util_1.failure(`Syntax error: ${e.message}`);
    }
}
exports.parse = parse;
function parseModule(source) {
    return pegjsParsers_1.moduleParser.parse(source);
}
exports.parseModule = parseModule;
function parseStatement(source) {
    return pegjsParsers_1.statementParser.parse(source);
}
exports.parseStatement = parseStatement;
function parseExpression(source) {
    return pegjsParsers_1.expressionParser.parse(source);
}
exports.parseExpression = parseExpression;
//# sourceMappingURL=index.js.map